import { useEffect, useRef, useState } from "react";
import api from "../lib/api";
import { Bell, MessageCircle, Mail } from "lucide-react";

export default function NotificationBell() {
  const [data, setData] = useState({ unread: 0, rows: [] });
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const load = () => api.get("/notifications").then(({ data }) => setData(data)).catch(() => {});
  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const markAll = async () => {
    await api.post("/notifications/read-all");
    load();
  };

  return (
    <div className="relative" ref={ref}>
      <button
        data-testid="notification-bell"
        onClick={() => setOpen((o) => !o)}
        className="relative p-2 text-[#0E2240] hover:bg-gray-100 rounded-sm transition-colors duration-200"
        aria-label="Notifications"
      >
        <Bell size={18} strokeWidth={1.75} />
        {data.unread > 0 && (
          <span data-testid="notification-unread-count" className="absolute -top-0.5 -right-0.5 bg-[#BB162B] text-white text-[10px] font-semibold rounded-full min-w-[16px] h-4 px-1 flex items-center justify-center tabular-nums">
            {data.unread}
          </span>
        )}
      </button>
      {open && (
        <div data-testid="notification-panel" className="absolute right-0 mt-1 w-80 max-w-[90vw] bg-white border border-gray-200 rounded-sm z-50">
          <div className="flex items-center justify-between px-4 py-2.5 border-b border-gray-200">
            <span className="text-xs font-semibold uppercase tracking-wider text-[#6B7280]">Notifications</span>
            {data.unread > 0 && (
              <button data-testid="notification-mark-all" onClick={markAll} className="text-[11px] text-[#1E5AA8] hover:underline">
                Mark all read
              </button>
            )}
          </div>
          <div className="max-h-80 overflow-y-auto">
            {data.rows.length === 0 ? (
              <div className="px-4 py-8 text-center text-xs text-[#6B7280]">No notifications</div>
            ) : data.rows.map((n) => (
              <div key={n.notif_id} className={`px-4 py-3 border-b border-gray-100 last:border-0 ${n.read ? "" : "bg-[#BF9B30]/5"}`}>
                <div className="flex items-start gap-2">
                  {n.channel === "whatsapp" && <MessageCircle size={13} className="text-[#1B7F3B] mt-0.5 shrink-0" />}
                  {n.channel === "email" && <Mail size={13} className="text-[#1E5AA8] mt-0.5 shrink-0" />}
                  <div className="min-w-0">
                    <div className="text-xs font-medium text-[#0E2240]">
                      {n.title}
                      {n.channel === "whatsapp" && <span className="ml-1.5 text-[9px] uppercase tracking-wider text-[#1B7F3B]">WhatsApp (mocked)</span>}
                      {n.channel === "email" && <span className="ml-1.5 text-[9px] uppercase tracking-wider text-[#1E5AA8]">Email (mocked)</span>}
                    </div>
                    <div className="text-[11px] text-[#6B7280] mt-0.5 leading-snug">{n.body}</div>
                    <div className="text-[10px] text-[#6B7280]/70 mt-1 tabular-nums">{new Date(n.created_on).toLocaleString("en-IN")}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
